'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var inject = {};

exports.__exports = inject;
